import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import '../index.css';
import App from '../App';
import {withStyles} from 'material-ui/styles';

// React Router
import { BrowserRouter as Router, Route } from 'react-router-dom';


const styles = {
    root: {
        'font-family': "'Lato','Helvetica-Neue'"
    }
}


const Root = ({store}) => (
    <Provider store={store}>
        <Router>
            <Route path="/:filter?" component={App} />
        </Router>
    </Provider>
)

Root.propTypes = {
    store: PropTypes.object.isRequired
};

export default withStyles(styles)(Root)


// WEBPACK FOOTER //
// ./src/Components/Root.js